import { deepMerge } from './deep-merge';
import actionItems from '../locales/en/action-items.json';
import billing from '../locales/en/billing.json';
import common from '../locales/en/common.json';
import dashboard from '../locales/en/dashboard.json';
import documents from '../locales/en/documents.json';
import help from '../locales/en/help.json';
import location from '../locales/en/location.json';
import notifications from '../locales/en/notifications.json';
import orgAuditDetails from '../locales/en/organizations/audit-details.json';
import orgAudits from '../locales/en/organizations/audits.json';
import orgDocuments from '../locales/en/organizations/documents.json';
import orgLocations from '../locales/en/organizations/locations.json';
import orgNotifications from '../locales/en/organizations/notifications.json';
import orgOrganization from '../locales/en/organizations/organization.json';
import orgSibContracts from '../locales/en/organizations/sib-contracts.json';
import orgSubsidiary from '../locales/en/organizations/subsidiary.json';
import orgVendors from '../locales/en/organizations/vendors.json';
import orgWork from '../locales/en/organizations/work.json';
import projects from '../locales/en/projects.json';
import reports from '../locales/en/reports.json';
import savings from '../locales/en/savings.json';
import services from '../locales/en/services.json';
import settings from '../locales/en/settings.json';
import subsidiary from '../locales/en/subsidiary.json';
import tasks from '../locales/en/tasks.json';
import teamMembers from '../locales/en/team-members.json';
import teams from '../locales/en/teams.json';
import templates from '../locales/en/templates.json';
import tickets from '../locales/en/tickets.json';
import vendors from '../locales/en/vendors.json';

const organizations = deepMerge(
  orgOrganization,
  orgLocations,
  orgVendors,
  orgSibContracts,
  orgAudits,
  orgAuditDetails,
  orgWork,
  orgDocuments,
  orgSubsidiary,
  orgNotifications
);

export const resources = {
  en: {
    common,
    dashboard,
    billing,
    documents,
    help,
    location,
    reports,
    savings,
    services,
    subsidiary,
    tickets,
    vendors,
    projects,
    'team-members': teamMembers,
    //extension namespace
    tasks,
    actionItems,
    organizations,
    teams,
    templates,
    settings,
    notifications,
  },
};

export const supportedLngs = Object.keys(resources);

export const fallbackLng = supportedLngs[0];

export const ns = Object.keys(resources[fallbackLng as keyof typeof resources]);

export type Resource = typeof resources.en;

export type Namespace = keyof Resource;
